module.exports = __webpack_public_path__ + "img/住宿发票示例 (1).c45c4e4f.png";